module.exports = __webpack_public_path__ + "70fca6f09dda1f5abb2ba09d9678075c.patt";